import { RouteRecordRaw } from 'vue-router'
import DocumentList from '@/pages/document/document-list/DocumentList.vue'
import DocumentSingle from '@/pages/document/single/DocumentSingle.vue'
import DocumentPreview from '@/pages/document/single/tabs/Preview.vue'
import DocumentRequisites from '@/pages/document/single/tabs/requisites/Requisites.vue'
import DocumentRoute from '@/pages/document/single/tabs/route/Route.vue'
import DocumentAcceptance from '@/pages/document/single/tabs/acceptance/Acceptance.vue'
import DocumentAttachments from '@/pages/document/single/tabs/Attachments.vue'
import DocumentComments from '@/pages/document/single/tabs/Comments.vue'
import DocumentRelation from '@/pages/document/single/tabs/Relation.vue'
import DocumentVersions from '@/pages/document/single/tabs/Versions.vue'
import DocumentHistory from '@/pages/document/single/tabs/History.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/document-list-draft',
    name: 'document-list-draft',
    component: DocumentList,
    meta: {
      title: 'Чернетка',
    },
  },
  {
    path: '/document-list-in-progress',
    name: 'document-list-in-progress',
    component: DocumentList,
    meta: {
      title: 'На погодженні',
    },
  },
  {
    path: '/document-list-revision',
    name: 'document-list-revision',
    component: DocumentList,
    meta: {
      title: 'Доопрацювання',
    },
  },

  {
    path: '/document-list-signature-today',
    name: 'document-list-signature-today',
    component: DocumentList,
    meta: {
      title: 'На сьогодні (підпис)',
    },
  },
  {
    path: '/document-list-signature-terminated',
    name: 'document-list-signature-terminated',
    component: DocumentList,
    meta: {
      title: 'Протерміновані (підпис)',
    },
  },
  {
    path: '/document-list-signature-terminating',
    name: 'document-list-signature-terminating',
    component: DocumentList,
    meta: {
      title: 'Термін наближається (підпис)',
    },
  },

  {
    path: '/document-list-agreement-today',
    name: 'document-list-agreement-today',
    component: DocumentList,
    meta: {
      title: 'На сьогодні (погодж.)',
    },
  },
  {
    path: '/document-list-agreement-terminated',
    name: 'document-list-agreement-terminated',
    component: DocumentList,
    meta: {
      title: 'Протерміновані (погодж.)',
    },
  },
  {
    path: '/document-list-agreement-terminating',
    name: 'document-list-agreement-terminating',
    component: DocumentList,
    meta: {
      title: 'Термін наближається (погодж.)',
    },
  },

  {
    path: '/document-list-acceptance',
    name: 'document-list-acceptance',
    component: DocumentList,
    meta: {
      title: 'Мені на ознайомлення',
    },
  },
  {
    path: '/document-list-accepted',
    name: 'document-list-accepted',
    component: DocumentList,
    meta: {
      title: 'Ознайомлені мною',
    },
  },
  {
    path: '/document-list-me',
    name: 'document-list-me',
    component: DocumentList,
    meta: {
      title: 'Мої документи',
    },
  },
  {
    path: '/document-list-incoming',
    name: 'document-list-incoming',
    component: DocumentList,
    meta: {
      title: 'Мої документи',
    },
  },

  {
    path: '/document/:uuid',
    name: 'document-single',
    component: DocumentSingle,
    meta: {
      title: 'Документ',
      tabList: true,
    },
    redirect: { name: 'document-preview' },
    children: [
      {
        path: 'preview',
        name: 'document-preview',
        component: DocumentPreview,
        meta: {
          title: 'Документ',
        },
      },
      {
        path: 'requisites',
        name: 'document-requisites',
        component: DocumentRequisites,
        meta: {
          title: 'Реквізити',
        },
      },
      {
        path: 'route',
        name: 'document-route',
        component: DocumentRoute,
        meta: {
          title: 'Маршрут',
        },
      },
      {
        path: 'acceptance',
        name: 'document-acceptance',
        component: DocumentAcceptance,
        meta: {
          title: 'Ознайомлення',
        },
      },
      {
        path: 'attachments',
        name: 'document-attachments',
        component: DocumentAttachments,
        meta: {
          title: 'Вкладення',
        },
      },
      {
        path: 'comments',
        name: 'document-comments',
        component: DocumentComments,
        meta: {
          title: 'Комантарі',
        },
      },
      {
        path: 'relation',
        name: 'document-relation',
        component: DocumentRelation,
        meta: {
          title: 'Звʼязки',
        },
      },
      {
        path: 'versions',
        name: 'document-versions',
        component: DocumentVersions,
        meta: {
          title: 'Версії',
        },
      },
      {
        path: 'history',
        name: 'document-history',
        component: DocumentHistory,
        meta: {
          title: 'Історія',
        },
      },
    ],
  },
]

export default routes
